export default __webpack_public_path__ + "static/media/politics.3f34e20e.pdf";